module.exports = __webpack_public_path__ + "img/icon_xueke.c5c790d8.svg";